import { useState } from "react";
import { BackButton } from "../components/backButton.jsx";
import { HeadLogo } from "../components/headLogo.jsx";

function SignUpView({ onSignUp }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");



  function handleSignUpClickACB() {
    if (!firstName || !lastName || !email || !password) {
      alert("Please fill in all fields.");
      return;
    }

    onSignUp(email, password, firstName, lastName);
  }

  return (
    <div className="centerView">
      <HeadLogo />
      <BackButton />
      <div className="container">
        <div className="header">Sign Up</div>
        <div className="getstarted">
          You’re not in our system yet. Sign up and let the hunt begin!
        </div>

        <div className="signupinput">
          <input
            className="nameinput"
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>
        <div className="signupinput">
          <input
            className="nameinput"
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>
        <div className="signupinput">
          <input
            className="emailinput"
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="signupinput">
          <input
            className="passwordinput"
            type="password"
            placeholder="Set password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div>
          <button
            className="signup-login-button"
            onClick={handleSignUpClickACB}
          >
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
}

export { SignUpView };
